import { observer } from 'mobx-react-lite';
import { withDefaultProps } from 'react-default-props-context';
import { cn } from 'src/frames/utils/cn';
import './SkipButton.scss';
import { QuestionT } from '../../api/types/QuestionT';
import { trackEvent } from '../../tracking/utils/initTracking';

type PropsT = {
  className?: any;
  label?: string;
  disabled?: boolean;
};

type DefaultPropsT = {
  questionDisplayNr: number;
  question: QuestionT;
  goToNextPage: () => void;
};

export const SkipButton = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    return (
      <button
        className={cn(
          'SkipButton',
          {
            'SkipButton--disabled': props.disabled,
          },
          props.className
        )}
        disabled={props.disabled}
        onClick={() => {
          if (props.question) trackEvent('click_skip', 'Question Details', `${props.questionDisplayNr}`);

          if (!(props.disabled ?? false)) props.goToNextPage();
        }}
      >
        {props.label ?? 'Überspringen'}
      </button>
    );
  })
);
